<template>
  <IndexPc class="pc-only" v-bind="props" :tags="tags" />
  <IndexM class="m-only" v-bind="props" :tags="tags" />
</template>
<script lang="ts" setup>
import type { Character } from '~/api/interface/character';
import IndexM from './index-m.vue';
import IndexPc from './index-pc.vue';
import type { DetailTag } from './interface';

interface DetailDescriptionProps {
  character?: Character | null;
}

const props = defineProps<DetailDescriptionProps>();

const tags = computed(() => {
  const tagArr: DetailTag[] = [];

  Object.values(props.character?.tag_tree || {})
    .filter(tt => tt.outer_id !== 'collection_series')
    .forEach(tag => {
      if (tag.is_show) {
        const tagDetail = {
          tag_name: tag.tag_name,
          tag_id: tag.tag_id,
          children: Object.values(tag.children || {})
            .filter(child => child.is_show)
            .map(child => ({
              ...child.children,
              tag_id: child.tag_id,
              tag_name: child.tag_name,
            })),
        };

        tagArr.push(tagDetail);
      }
    });

  return tagArr;
});
</script>
<style lang="scss" scoped></style>
